import { useState } from "react";
import { Eye, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { SupporterProfileHeader } from "@/components/profile/SupporterProfileHeader";

export function VipPreviewButton({ className = "", testId = "vip-preview-btn" }) {
  const { user } = useAuth();
  const [p, setP] = useState(null);
  const [busy, setBusy] = useState(false);
  if (!user) return null;
  const open = async () => {
    setBusy(true);
    try { const { data } = await api.get(`/users/${user.user_id}/profile`); setP({ ...data, is_supporter: true, supporter: true }); }
    catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };
  return (
    <>
      <button type="button" onClick={open} disabled={busy} data-testid={testId}
        className={`inline-flex items-center justify-center gap-2 h-11 px-5 rounded-full border-2 border-rose-300 text-rose-100 font-bold text-sm hover:bg-white/10 active:scale-95 transition-transform ${className}`}>
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Eye className="w-4 h-4" />} So sähe dein Unterstützer-Profil aus
      </button>
      <Dialog open={!!p} onOpenChange={(o) => !o && setP(null)}>
        <DialogContent className="max-w-lg sm:max-w-3xl w-[calc(100vw-1.5rem)] p-0 overflow-hidden rounded-3xl border-pink-200 bg-[#fff7f9] max-h-[90vh] overflow-y-auto" data-testid="vip-preview-dialog">
          <DialogTitle className="sr-only">Vorschau Unterstützer-Profil</DialogTitle>
          <DialogDescription className="sr-only">So sehen andere dein Profil als Projekt Unterstützer</DialogDescription>
          <div className="sticky top-0 z-10 text-center text-[11px] font-extrabold uppercase tracking-[0.25em] py-2 bg-gradient-to-r from-[#9f1239] via-[#e11d48] to-[#9f1239] text-white">Vorschau · so sehen dich andere als Projekt Unterstützer</div>
          <div className="pointer-events-none select-none p-3">{p && <SupporterProfileHeader p={{ ...p, is_me: false }} onChanged={() => {}} />}</div>
          <div className="p-4 pt-0">
            <a href="/community-unterstuetzen" data-testid="vip-preview-cta" className="w-full h-12 rounded-full vip-gold-metal font-extrabold inline-flex items-center justify-center">Jetzt Projekt Unterstützer werden 💖</a>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
